import { FC, useState } from "react";
import { Button, Card, Icon, Input, PasswordStrengthChecker } from "@components";
import { ColorsEnum } from "@utilities/enums";
import { PasswordChangeProps } from "./interfaces";

export const PasswordChange:FC<PasswordChangeProps> = ({
    isLoadingPasswordChange,
    updateUserPasswordError,
    isEditingUpdatePassword, setIsEditingUpdatePassword,
    isValidToUpdatingPassword, setIsValidToUpdatingPassword,
    currentPassword, setCurrentPassword,
    newPassword, setNewPassword,
    confirmPassword, setConfirmPassword,
    onToggleEditingUpdatedPassword, handleUpdatePassword,
}) => {

    const [showPasswordCurrent, setShowPasswordCurrent] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

    return (
        <Card title="Modifier le mot de passe" collapsible>
            {
                isEditingUpdatePassword ? (
                    <div className="space-y-4">
                        <Input
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Mot de passe actuel"
                            type={showPasswordCurrent ? "text" : "password"}
                            leftIcon={(
                                <Icon iconName="LockKeyhole"
                                    color={ColorsEnum.PRIMARY}
                                    size={25}
                                />
                            )}
                            rightIcon={(
                                <Icon
                                    onPress={()=> setShowPasswordCurrent(!showPasswordCurrent)}
                                    iconName={showPasswordCurrent ? "EyeClosed" : "Eye"}
                                    size={25}
                                    color={ColorsEnum.SECONDARY}
                                />
                            )}
                        />
                        <Input
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Nouveau mot de passe"
                            type={showPassword ? "text" : "password"}
                            leftIcon={(
                                <Icon iconName="LockKeyhole"
                                    color={ColorsEnum.PRIMARY}
                                    size={25}
                                />
                            )}
                            rightIcon={(
                                <Icon
                                    onPress={()=> setShowPassword(!showPassword)}
                                    iconName={showPassword ? "EyeClosed" : "Eye"}
                                    size={25}
                                    color={ColorsEnum.SECONDARY}
                                />
                            )}
                        />
                        <Input
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirmer le nouveau mot de passe"
                            type={showConfirmPassword ? "text" : "password"}
                            leftIcon={(
                                <Icon iconName="LockKeyhole"
                                    color={ColorsEnum.PRIMARY}
                                    size={25}
                                />
                            )}
                            rightIcon={(
                                <Icon
                                    onPress={()=> setShowConfirmPassword(!showConfirmPassword)}
                                    iconName={showConfirmPassword ? "EyeClosed" : "Eye"}
                                    size={25}
                                    color={ColorsEnum.SECONDARY}
                                />
                            )}
                        />
                        {
                            newPassword && (
                                <PasswordStrengthChecker
                                    password={newPassword}
                                    confirmPassword={confirmPassword}
                                    onValidityChange={(valid: boolean) => setIsValidToUpdatingPassword(valid)}
                                />
                            )
                        }
                        <div className="flex gap-1 justify-between">
                            <Button
                                className="btn-neutral rounded-md"
                                disabled={isLoadingPasswordChange || !isValidToUpdatingPassword}
                                onClick={handleUpdatePassword}
                            >
                                {isLoadingPasswordChange ? "Modification en cours..." : "Changer le mot de passe"}
                            </Button>

                            <Button
                                onClick={()=> setIsEditingUpdatePassword(false)}
                                className="btn-secondary rounded-md"
                                disabled={isLoadingPasswordChange}
                            >
                                Annuler
                            </Button>
                        </div>

                        {
                            updateUserPasswordError && (
                                <p className="text-red-500 text-sm mt-2">{updateUserPasswordError?.message}</p>
                            )
                        }
                    </div>
                ) : (
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">**********</span>
                            <Button
                                onClick={onToggleEditingUpdatedPassword}
                                className="btn-primary"
                            >
                                Modifier le mot de passe
                            </Button>
                        </div>
                    </div>
                )}
        </Card>
    );
};
